import React, { useEffect } from 'react';
import { useSelector } from '../store';

export const iframeRef = React.createRef<HTMLIFrameElement>();

const UpIcon:React.FC = () => {

    const auth: any = useSelector((state) => state.authentication);

    let faq_url = "";
    if (auth.data.res_data !== undefined) {
      if (auth.data.res_data.faq_url !== undefined) {
        faq_url = auth.data.res_data.faq_url;
      }
    }
    
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 1200);
    },[]);

  return (
    <>
        <div className='faqIframe'>
            <iframe ref={iframeRef} src={faq_url} />
        </div>
    </>
  );
}

export const reloadIframe = () => {
  if (iframeRef.current) {
      iframeRef.current.src += '';
  }
};

export default UpIcon;